<template>
  <div class="inline-block-container">

    <span @click="openModalAction" class="cursor-pointer">
      <img src="/images/btn_pluspey.svg" class="img">
    </span>

    <ModalBackground v-if="isActive"/>
    <div v-if="isActive" class="modal-container" @click.self="closeModalAction">
      <div class="inner">
        <div class="close-button-container" @click="closeModalAction">
          <CloseButton/>
        </div>
        <FormHelper class="form-container" @callback="callback" :formSettings="formSettings"/>
      </div>
    </div>
    <div v-if="$isDebug() && debugVerifyToken" class="debug-option-container">
      <router-link :to="{name: 'Register', params:{token: debugVerifyToken}}" class="link">[DEBUG]メール認証</router-link>
    </div>

  </div>
</template>

<script>

import ModalBackground from '@/components/common/ModalBackground';
import FormHelper from '@/components/common/FormHelper';
import CloseButton from '@/components/user/CloseButton';

export default {
  props: ['kidsId'],
  components: {
    ModalBackground,
    FormHelper,
    CloseButton
  },
  data () {
    return {
      formSettings: { //フォームの設定を記載
        store: 'pays',
        dispatch: 'add',
        header: 'ペイをあげる',
        forms: {
          pay: {
            label: 'あげるペイ',
            type: 'text',
            value: null,
            require: true,
            placeholder: 'あげるペイ',
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          },
          note: {
            label: 'メモ',
            type: 'text',
            value: null,
            require: true,
            placeholder: 'メモを追加',
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          },
          kids_id: {
            label: '',
            type: 'hidden',
            value: null,
            require: null,
            placeholder: '',
            default: '',
            validate: [],
            option: {}
          },
        },
        useSessionId: true,
        submit: {
          label: 'ペイをあげる',
          color: 'b'
        },
        info: []
      },
      option: {
        is1Button: true,
        buttonLabel: '確認',
        callback: 'AddPaysFinish',
        callbackO: 'AddPaysFinish',
        messages: ['ペイをあげました']
      },
      isActive: false,
      debugVerifyToken: null
    };
  },
  methods: {
    openModalAction: function () {
      console.log('openModalAction');

      this.formSettings.forms.kids_id.value = this.kidsId;

      this.isActive = true;

      scrollTo(0, 0);
    },
    closeModalAction: function () {
      console.log('closeModalAction');
      this.isActive = false;
    },
    callback: function (dispatcher, value) {
      console.log('callback', dispatcher, value);

      this.isActive = false;

      // 完了メッセージ
      this.$store.dispatch('message/open', this.option).then();

    }
  }
};

</script>

<style lang="scss" scoped>

  .icon-container {

    background: #eee;
    border: 1px solid #ddd;
    border-radius: 10px;
    margin: 5px;
    padding: 5px;
    width: 140px;
    font-size: 80px;
    text-align: center;
  }

  .text {
    font-size: 22px;
    text-align: center;
  }

  .pay-text {
    font-size: 20px;
    text-align: center;
  }

  .add-container {
    background: #eee;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin: 5px;
    padding: 5px;
    width: 250px;
    text-align: center;
    cursor: pointer;
  }

  // 801以上
  @media screen and (min-width: 801px) {

  }

  // 800まで
  @media screen and (max-width: 800px) {
  }

</style>
